module.exports = __webpack_public_path__ + "static/media/kapten.2db5cbe9.mp3";